<template>
  <div>
    <Component59 />
    <Component60 />
    <Component61 />
  </div>
</template>
<script>
import Component59 from '@/v2/auto/sections/59-sense.vue'
import Component60 from '@/v2/auto/sections/60-condiction.vue'
import Component61 from '@/v2/auto/sections/61-guard.vue'
export default {
  components: {
    Component59,
    Component60,
    Component61,
  },
}
</script>
